// Basic Routing setup
WiseMetering.Router = Backbone.Marionette.AppRouter.extend({
    appRoutes: {
        '': 'drawDefault',
        'actuators': 'drawActuators',
        'admin': 'drawAdmin',
        'alarms': 'drawAlarms',
        'alarms/:id/edit': 'drawEditAlarm',
        'alarms/create?indicator_id=:indicator_id': 'drawCreateAlarm',
        'alarms/bulk_create': 'drawBulkCreateAlarms',
        'alarms/bulk_delete': 'drawBulkDeleteAlarms',
        'alarms/bulk_edit': 'drawBulkEditAlarms',
        'alarms/:id/show': 'drawShowAlarm',
        'all_tenants': 'drawTenants',
        'all_tenants/:id?*querystring': 'drawTenant',
        'all_tenants/:id': 'drawTenant',
        'sites/:id/:view?*querystring': 'drawSite',
        'sites/:id/:view': 'drawSite',
        'site_tags': 'drawSiteTags',
        'chat': 'drawChat',
        'circuits': 'drawCircuits',
        'circuits/:id?*querystring': 'drawCircuit',
        'circuits/:id': 'drawCircuit',
        'circuit_types': 'drawCircuitTags',
        'companies': 'drawCompanies',
        'contracts/:id/:view?*querystring': 'drawContract',
        'contracts/:id/:view': 'drawContract',
        'custom_dashboard': 'drawCustomDashboard',
        'dashboard': 'drawDashboard',
        'devices': 'drawDevices',
        'events': 'drawEvents',
        'events?*querystring': 'drawEvents',
        'etls': 'drawEtls',
        'folders/:id?*querystring': 'drawFolder',
        'folders/:id': 'drawFolder',
        'global_indicators': 'drawGlobalIndicators',
        'groups': 'drawGroups',
        'holidays': 'drawHolidays',
        'home': 'drawDashboard',
        'indicators': 'drawIndicators',
        'indicators/:id/:view?*querystring': 'drawIndicator',
        'indicators/:id/:view': 'drawIndicator',
        'integrations/:id/:view?*querystring': 'drawIntegration',
        'integrations/:id/:view': 'drawIntegration',
        'integration_licenses/:id/:view?*querystring': 'drawIntegrationLicense',
        'integration_licenses/:id/:view': 'drawIntegrationLicense',
        'integration_licenses/:id?*querystring': 'drawIntegrationLicense',
        'integration_licenses/:id': 'drawIntegrationLicense',
        'integration_licenses/:id/integrations/new': 'drawNewIntegration',
        'integration_licenses/:license_id/integrations/:id/edit': 'drawEditIntegration',
        'leads': 'drawLeads',
        'map': 'drawMap',
        'login': 'drawLogin',
        'markers': 'drawMarkers',
        'notifications': 'drawNotifications',
        'organizations/create': 'createOrganization',
        'organizations/:id': 'drawOrganization',
        'organizations/:id/edit': 'editOrganization',
        'readings': 'drawReadings',
        'reports': 'drawReports',
        'seus/:id?*querystring': 'drawSeu',
        'seus/:id': 'drawSeu',
        'signup': 'drawSignup',
        'tariffs': 'drawTariffs',
        'reset_password/:id': 'drawResetPassword',
        'root_objects/:id/:view?*querystring': 'drawRootObject',
        'root_objects/:id/:view': 'drawRootObject',
        'root_objects/:id?*querystring': 'drawRootObject',
        'root_objects/:id': 'drawRootObject',
        'tenants/:id?*querystring': 'drawTenant',
        'tenants/:id': 'drawTenant',
        'tree': 'drawTree',
        'users': 'drawUsers',
        'user_profile': 'drawUserProfile',
        'utilities/:id/:view?*querystring': 'drawUtility',
        'utilities/:id/:view': 'drawUtility',
        'wise-store': 'drawWiseStore',
        'zone_attributes': 'drawZoneAttributes',
        'zones/:id/:view?*querystring': 'drawZone',
        'zones/:id/:view': 'drawZone',
        '*path': 'drawDefault'
    }
});

WiseMetering.addInitializer(() => {
    $(document).on('click', 'a[href^="/"]', function (event) {
        event.preventDefault();
        const href = $(event.currentTarget).attr('href');
        Backbone.history.navigate(href, { trigger: true });
    });

    new WiseMetering.Router({ controller: WiseMetering.controller });
    Backbone.history.start({ pushState: true, silent: true });
});
